/**
 * Coluna do Kanban de Vistorias, baseada na coluna compartilhada somente leitura.
 *
 * @version 1.0.0
 * RELEASE: 2026-09-26 v1.0.0 - Cursor, fallback sem overflow e skeleton padronizados.
 */
import { ReadonlyKanbanColumn } from '@/components/kanban/ReadonlyKanbanColumn';
import { useInspectionsColumn, type InspectionFilters, type InspectionListRow } from '@/hooks/useChecklistInstancesList';
import { InspectionKanbanCard } from './InspectionKanbanCard';
import type { InspectionKanbanColumnDef } from './inspectionKanbanColumns';

interface InspectionKanbanColumnProps {
  column: InspectionKanbanColumnDef;
  filters: InspectionFilters;
  total: number;
  onOpen: (id: string) => void;
  onOpenCustomer: (inspection: InspectionListRow) => void;
  canOpenCustomer: boolean;
  /** Abre o modal do veículo vinculado (IDs congelados no snapshot). */
  onOpenVehicle: (inspection: InspectionListRow) => void;
  canOpenVehicle: boolean;
}

export function InspectionKanbanColumn({
  column, filters, total, onOpen, onOpenCustomer, canOpenCustomer, onOpenVehicle, canOpenVehicle,
}: InspectionKanbanColumnProps) {
  const {
    inspections,
    isLoading,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
  } = useInspectionsColumn(column.status, filters);

  return (
    <ReadonlyKanbanColumn
      label={column.label}
      count={total}
      barClass={column.barClass}
      headerClass={column.headerClass}
      itemCount={inspections.length}
      isLoading={isLoading}
      isFetchingNextPage={isFetchingNextPage}
      hasNextPage={hasNextPage}
      fetchNextPage={fetchNextPage}
      emptyLabel="Nenhuma vistoria"
    >
      {inspections.map((inspection) => (
        <InspectionKanbanCard
          key={inspection.id}
          inspection={inspection}
          onOpen={onOpen}
          onOpenCustomer={onOpenCustomer}
          canOpenCustomer={canOpenCustomer && !!(inspection.customer_id || inspection.contact_id)}
          onOpenVehicle={onOpenVehicle}
          canOpenVehicle={canOpenVehicle && !!inspection.vehicle_id}
        />
      ))}
    </ReadonlyKanbanColumn>
  );
}